import { render, staticRenderFns } from "./InfoView.vue?vue&type=template&id=9cfe2bf4&scoped=true&"
import script from "./InfoView.vue?vue&type=script&lang=js&"
export * from "./InfoView.vue?vue&type=script&lang=js&"
import style0 from "./InfoView.vue?vue&type=style&index=0&id=9cfe2bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfe2bf4",
  null
  
)

export default component.exports